// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportHistoryConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  CRITERIA_LIST: [
    {
      value: 'All',
      get label() {
        return localizer.getText('COMMON_LABEL_ALL');
      }
    },
    {
      value: 'Version',
      get label() {
        return localizer.getText('REPORT_HISTORY_CONSTANTS_CRITERIA_LIST_VERSION');
      }
    },
    {
      value: 'Status',
      get label() {
        return localizer.getText('COMMON_LABEL_STATUS');
      }
    },
    {
      value: 'Modified',
      get label() {
        return localizer.getText('REPORT_HISTORY_CONSTANTS_CRITERIA_LIST_EDITED_DATE');
      }
    },
    {
      value: 'ModifiedBy',
      get label() {
        return localizer.getText('REPORT_HISTORY_CONSTANTS_CRITERIA_LIST_EDITED_BY');
      }
    }
  ],
  TABLE_DEF: {
    version: {
      key: 'version',
      columnKey: 'version',
      width: 100,
      get title() {
        return localizer.getText('REPORT_HISTORY_CONSTANTS_CRITERIA_LIST_VERSION');
      },
      sortable: true
    },
    status: {
      key: 'status',
      columnKey: 'status',
      width: 100,
      get title() {
        return localizer.getText('COMMON_LABEL_STATUS');
      },
      sortable: true
    },
    editedDate: {
      key: 'modified',
      columnKey: 'modified',
      width: 200,
      get title() {
        return localizer.getText('REPORT_HISTORY_CONSTANTS_CRITERIA_LIST_EDITED_DATE');
      },
      sortable: true
    },
    editedBy: {
      key: 'modifiedBy',
      columnKey: 'modifiedBy',
      width: 215,
      get title() {
        return localizer.getText('REPORT_HISTORY_CONSTANTS_CRITERIA_LIST_EDITED_BY');
      },
      sortable: true
    },
    action: {
      width: 150,
      resizable: false,
      fixed: true,
      align: 'center',
      get title() {
        return localizer.getText('COMMON_LABEL_ACTION');
      }
    }
  },
  TABLE_WIDTH: 590,
  TOOL_TIP: {
    get DESIGN() {
      return localizer.getText('REPORT_HISTORY_CONSTANTS_DESIGN');
    },
    get COPY() {
      return localizer.getText('REPORT_HISTORY_CONSTANTS_COPY');
    },
    get MOVE() {
      return localizer.getText('REPORT_HISTORY_CONSTANTS_MOVE');
    },
    get DELETE() {
      return localizer.getText('REPORT_HISTORY_CONSTANTS_DELETE');
    }
  },
  STATUS: {
    get ACTIVE() {
      return localizer.getText('COMMON_LABEL_ACTIVE');
    },
    get ARCHIVED() {
      return localizer.getText('COMMON_LABEL_ARCHIVED');
    }
  },
  MESSAGES: {
    get M01a() {
      return localizer.getText('REPORT_HISTORY_CONSTANTS_MESSAGE_DELETE_ARCHIVED');
    },
    get M01b() {
      return localizer.getText('REPORT_HISTORY_CONSTANTS_MESSAGE_DELETE_ACTIVE');
    }
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ReportHistoryConstants.js